// Canonical payment-status model used across the app: Paid / Partial / Unpaid.
// Legacy / free-text statuses are mapped into these three buckets so "unpaid"
// bills always stand out consistently on the Spends Log and Invoices views.

export const PAY_FILTERS = ["all", "Paid", "Partial", "Unpaid"];

export function normPayStatus(v) {
  const s = String(v || "").trim().toLowerCase();
  if (["paid", "paid in full", "fully paid"].includes(s)) return "Paid";
  if (["partial", "partially paid", "part", "part paid", "partly paid"].includes(s)) return "Partial";
  // everything else (pending, not paid, overdue, no po reference, unspecified,
  // blank, …) is treated as not-yet-paid so outstanding bills are highlighted.
  return "Unpaid";
}

export function paymentTotals(rows) {
  const t = {
    all: { amount: 0, count: 0 },
    Paid: { amount: 0, count: 0 },
    Partial: { amount: 0, count: 0 },
    Unpaid: { amount: 0, count: 0 },
  };
  (rows || []).forEach((r) => {
    const amt = Number(r.amount || 0) || 0;
    const k = normPayStatus(r.payment_status);
    t.all.amount += amt; t.all.count += 1;
    t[k].amount += amt; t[k].count += 1;
  });
  return t;
}
